import { render, staticRenderFns } from "./NsPhoneNumberLib.vue?vue&type=template&id=60cc7d74&scoped=true&"
import script from "./NsPhoneNumberLib.vue?vue&type=script&lang=js&"
export * from "./NsPhoneNumberLib.vue?vue&type=script&lang=js&"
import style0 from "./NsPhoneNumberLib.vue?vue&type=style&index=0&id=60cc7d74&lang=scss&scoped=true&"
import style1 from "./NsPhoneNumberLib.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cc7d74",
  null
  
)

export default component.exports